import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function FeaturedWeddings({ weddings }) {
  const items = weddings || [];
  if (!items.length) return null;
  return (
    <section data-testid="featured-weddings" className="py-16 md:py-28">
      <div className="max-w-[1500px] mx-auto px-5 md:px-10">
        <div className="flex items-end justify-between mb-10 md:mb-16">
          <div>
            <div className="eyebrow mb-3">The Portfolio</div>
            <h2 className="font-display italic text-4xl md:text-6xl leading-[1] tracking-tight">Featured Weddings</h2>
          </div>
          <Link to="/weddings" data-testid="featured-see-all" className="eyebrow link-underline hidden md:inline">See All Weddings →</Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-8">
          {items.slice(0, 4).map((w, i) => {
            const spans = [
              "md:col-span-7 md:row-span-2 aspect-[4/5]",
              "md:col-span-5 aspect-[4/5]",
              "md:col-span-5 aspect-[4/5]",
              "md:col-span-7 aspect-[4/5]",
            ];
            return (
              <Link
                key={w.id}
                to={`/weddings/${w.slug}`}
                data-testid={`featured-card-${w.slug}`}
                className={`group relative overflow-hidden hover-scale ${spans[i % spans.length]}`}
              >
                <img src={w.cover_url} alt={w.name} loading="lazy" className="w-full h-full object-cover" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/10 to-transparent" />
                <div className="absolute inset-0 p-6 md:p-8 flex flex-col justify-end">
                  <div className="eyebrow text-[color:var(--text-muted)] mb-2">{w.location}</div>
                  <div className="flex items-end justify-between gap-4">
                    <h3 className="font-display italic text-3xl md:text-5xl leading-[0.95] text-[color:var(--text)] max-w-[80%]">{w.name}</h3>
                    <ArrowUpRight size={22} className="text-[color:var(--text)] group-hover:text-[color:var(--accent)] transition-colors flex-shrink-0" />
                  </div>
                  {w.mood_line && <p className="mt-3 text-sm text-[color:var(--text-muted)] max-w-md line-clamp-2">{w.mood_line}</p>}
                </div>
              </Link>
            );
          })}
        </div>

        <div className="mt-10 md:hidden text-center">
          <Link to="/weddings" data-testid="featured-see-all-mobile" className="btn-pill btn-outline">See All Weddings</Link>
        </div>
      </div>
    </section>
  );
}
